import { createGlobalStyle, css } from 'styled-components';
import '@frete.com/fuel-fonts/satoshi/fontface.css';
import Resets from './resets';

const GlobalStyles = createGlobalStyle`
  ${Resets}
  .modal-proposal {
    z-index: 12;
  }

  /* Previne que o Hubspot sobreponha botão de nova viagem */
  #hubspot-messages-iframe-container {
    margin-bottom: 100px!important;
  }

  #root > div > header {
    ${({ theme }) => css`
      position: fixed;
      right: -${theme.spacing.km2};
    `}
  }
`;

export default GlobalStyles;
